import { generateAIFleetTokenLink } from './generateTokenLink';

export const ROUTE_NOTICE_STORAGE_KEY = 'route-notice-muted-until';
export const ROUTE_NOTICE_PREFERENCE_EVENT = 'route-notice-preference-changed';
export const ROUTE_NOTICE_MUTE_DURATION = 5 * 24 * 60 * 60 * 1000;
const SKIP_PARAM = 'skipRouteNotice';
const UNTIL_PARAM = 'routeNoticeUntil';

const validUntil = (value, now = Date.now()) => {
  const timestamp = Number(value);
  return Number.isFinite(timestamp) && timestamp > now
    ? Math.min(timestamp, now + ROUTE_NOTICE_MUTE_DURATION) : 0;
};

export const getRouteNoticeMutedUntil = () => {
  try {
    return validUntil(window.localStorage.getItem(ROUTE_NOTICE_STORAGE_KEY));
  } catch {
    return 0;
  }
};

export const setRouteNoticeMutedUntil = (until) => {
  const timestamp = validUntil(until);
  try {
    if (timestamp) window.localStorage.setItem(ROUTE_NOTICE_STORAGE_KEY, String(timestamp));
    else window.localStorage.removeItem(ROUTE_NOTICE_STORAGE_KEY);
  } catch {
    // 禁用本地存储时仍允许关闭公告和跨站跳转。
  }
  window.dispatchEvent(new Event(ROUTE_NOTICE_PREFERENCE_EVENT));
  return timestamp;
};

// 在自动登录清理 URL 之前读取；兼容原有仅带 userToken 的直达链接。
export const readRouteNoticeEntry = (search) => {
  const params = new URLSearchParams(search);
  return {
    skip: params.get(SKIP_PARAM) === '1' || Boolean(params.get('userToken')?.trim()),
    mutedUntil: validUntil(params.get(UNTIL_PARAM)),
  };
};

export const applyRouteNoticeEntry = (entry) => {
  const until = Math.max(getRouteNoticeMutedUntil(), validUntil(entry.mutedUntil));
  if (until) setRouteNoticeMutedUntil(until);

  const url = new URL(window.location.href);
  if (!url.searchParams.has(SKIP_PARAM) && !url.searchParams.has(UNTIL_PARAM)) return;
  url.searchParams.delete(SKIP_PARAM);
  url.searchParams.delete(UNTIL_PARAM);
  // 保留登录 token、其他业务参数、hash 和路由状态。
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
};

export const generateAccessRouteLink = (baseUrl, { isLoggedIn, userToken, mutedUntil = getRouteNoticeMutedUntil() } = {}) => {
  const hasToken = isLoggedIn && typeof userToken === 'string' && userToken.trim();
  const url = new URL(hasToken ? generateAIFleetTokenLink(userToken, baseUrl) : '/', baseUrl);
  url.searchParams.set(SKIP_PARAM, '1');
  const until = validUntil(mutedUntil);
  if (until) url.searchParams.set(UNTIL_PARAM, String(until));
  return url.toString();
};
